import config from 'constants/config'
import { createSelector } from 'reselect'

export const tourV2ShouldShowFilterToggles = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (currentRegionCode: string) => !config.CRUISES_REGIONS?.split(',').includes(currentRegionCode),
)

export const tourV2BaseTourFilters = createSelector(
  (state: App.State) => state.geo.currentRegionCode,
  (currentRegionCode: string): { holidayTypes?: Array<string>} => {
    const isCruisesAvailableInRegion = config.CRUISES_REGIONS?.split(',').includes(currentRegionCode)

    if (isCruisesAvailableInRegion) {
      return {
        holidayTypes: ['!Cruises'],
      }
    }

    return {}
  },
)
